<template>
    <div>
        <div class="row">
            <div class="col">
                <form class="form-horizontal">

                    <div class="pull-right">

                        <button type="button" @click="submit" class="btn btn-success m-2" href="#">Save</button>
                        <a class="btn" @click="cancel" href="#">Cancel</a>
                    </div><br>


                    <div class="form-group form-inline">
                        <label class="control-label col-md-2">Name:</label>
                        <input ref="list_name" v-model="list_name" class="form-control form-control-sm col-md-4"
                            type="text" :disabled="editmode" required>
                    </div>
                    <div class="form-group form-inline">
                        <label class="col-sm-2 align-self-start">List Items:</label>
                        <div class="col-sm-6 px-0">
                            <div>
                                <span>Item Name </span>
                                <span>[Display Label] </span>
                            </div>
                            <div>
                                <input ref="item_name" class="form-control form-control-sm col-md-4" type="text"
                                    id="item_name">
                                <input ref="item_label" class="form-control form-control-sm col-md-4" type="text"
                                    id="item_label">
                                <a class="btn" href="#" @click="add">Add</a>

                            </div>
                            <br>
                            <!-- This is old
                        <draggable
                            :list="list"
                            :disabled="!enabled"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false">
                            <transition-group type="transition">
                                <div class="list-group-item py-2"
                                    v-for="(element, idx) in list"
                                    :key="element.name">
                                    {{ element.name }}[{{element.label}}]
                                    <i class="close fa fa-times fa-sm" @click="removeAt(idx)"></i>
                                </div>
                            </transition-group>
                        </draggable> -->

                            <!-- <div id="list-demo">
                            <div class="widget-container">
                                <DxList
                                    :ref="dxref"
                                    :data-source="list"
                                    :repaint-changes-only="true"
                                     key-expr="name"
                                >
                                    <DxItemDragging
                                    data="list"
                                    :allow-reordering="true"
                                    :on-drag-start="onDragStart"
                                    :on-add="onAdd"
                                    :on-remove="onRemove"
                                    group="tasks"

                                    />
                                </DxList>
                            </div>
                        </div> -->

                            <!-- <DxSortable v-model:data="list" item-orientation="vertical" drag-direction="vertical"
                                group="kk" :allow-reordering="true" data="list" @drag-start="onTabDragStart($event)"
                                @reorder="onTabDrop($event)" @add="onTabDrop($event)" :allow-drop-inside-item="true">

                                <div v-for="(task, idx) in list" :key="task.name"
                                    style="background: #86C285; margin: 5px;" class="p-2">
                                    <div class="list-group-item dx-theme-text-color">
                                        {{ task.name }} [{{ task.label }}]
                                        <i class="closefa fa fa-trash fa-sm" style="cursor: pointer;"
                                            @click="removeAt(idx)"></i> -->
                            <!-- <i class="editfa fa fa-edit fa-sm" style="cursor: pointer;"
                                            @click="editTask(idx)" data-label="{{  task.name }}"></i> -->
                            <!-- <i class="fa" :class="task.isEditing ? 'fa-save' : 'fa-edit'" style="cursor: pointer;"
                                            @click="editTask(idx)" :data-name="task.name" :data-label="task.label"
                                            :data-id="idx">
                                        </i>
                                    </div>
                                </div>

                            </DxSortable> -->

                            <!-- input field area -->
                            <DxSortable v-model:data="list" item-orientation="vertical" drag-direction="vertical"
                                group="kk" :allow-reordering="true" data="list" @drag-start="onTabDragStart($event)"
                                @reorder="onTabDrop($event)" @add="onTabDrop($event)" :allow-drop-inside-item="true">
                                <div v-for="(task, idx) in list" :key="task.name"
                                    style="background: #86c285; margin: 5px" class="p-2">
                                    <div class="list-group-item dx-theme-text-color">

                                        <!-- If editing, show input fields -->
                                        <template v-if="task.isEditing">
                                            <input v-model="task.name"
                                                class="form-control form-control-sm d-inline-block col-md-4" readonly>
                                            <input v-model="task.label"
                                                class="form-control form-control-sm d-inline-block col-md-4">
                                        </template>

                                        <!-- If not editing, show the text -->
                                        <template v-else>
                                            {{ task.name }} [{{ task.label }}]
                                        </template>

                                        <!-- Delete Button -->
                                        <i class="closefa fa fa-trash fa-sm" style="cursor: pointer"
                                            @click="removeAt(idx)"></i>

                                        <!-- Edit / Save Button -->
                                        <i class="editfa fa fa-sm" :class="task.isEditing ? 'fa-save' : 'fa-edit'"
                                            style="cursor: pointer" @click="toggleEdit(idx)"></i>

                                    </div>
                                </div>
                            </DxSortable>

                            <input type="hidden" :value="list">
                        </div>
                    </div>
                </form>

            </div>
        </div>

        <!-- <div v-for="dropdown in ddlist" :key="dropdown.name">
            <details class="p-1">
                <summary class="text-lg p-1 rounded-lg border bg-green-200 font-weight-bold">{{ dropdown.name }}</summary>
                <div class="bg-green-300 ml-3 pl-2 text-lg ">Name: {{ dropdown.options.name }}</div>
                <div class="bg-green-300 ml-3 pl-2 text-lg">Label: {{ dropdown.options.label }}</div>
            </details>
        </div> -->


        <DxToast v-model:visible="isVisible" v-model:message="message" v-model:type="type" />
    </div>
</template>
<script>

import DxList, { DxItemDragging } from 'devextreme-vue/list';
import draggable from "vuedraggable";
import DxSortable from 'devextreme-vue/sortable';
import { DxToast } from "devextreme-vue/toast";



let id = 1;


export default {
    props: {
        tabData: {
            type: Object,
            default: () => ({}),
        },
        edit: {
            type: Boolean,
            default: false,
        },
        slug: String
    },
    components: {
        // draggable,
        DxList,
        DxItemDragging,
        DxSortable,
        DxToast,

    },
    data() {
        return {
            id: "",
            list_name: "",
            editmode: this.edit,
            enabled: true,
            draggingGroupName: "drag",
            sortableAttributes: "name",
            list: [],
            ddlist: [],
            dragging: false,
            dxref: "list-ref",
            isVisible: false,
            message: '',
            type: 'success',
            tempText2: [],
            editIndex: null,
            isEditing: []
        };

    },
    mounted() {
        //console.log(this.tabData.options);
        if (Object.keys(this.tabData).length > 0) {
            this.list_name = this.tabData.name;
            this.list = this.tabData.options;

        }
        this.get();
    },
    created: function () {

    },
    computed: {
        draggingInfo() {
            return this.dragging ? "under drag" : "";
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    methods: {
        onTabDragStart(e) {
            e.itemData = e.fromData[e.fromIndex];
        },
        onListReorder(e) {
            const list = this.tags.splice(e.fromIndex, 1)[0];
            this.tags.splice(e.toIndex, 0, list);
        },
        onTabDrop(e) {
            e.fromData.splice(e.fromIndex, 1);
            e.toData.splice(e.toIndex, 0, e.itemData);
        },

        onDragStart(e) {
            e.itemData = this[e.fromData][e.fromIndex];
        },
        onAdd(e) {
            const data = [...this[e.toData]];
            data.splice(e.toIndex, 0, e.itemData);
            this[e.toData] = data;
            console.log("data" + data);

        },
        onRemove(e) {
            const data = [...this[e.fromData]];
            data.splice(e.fromIndex, 1);
            this[e.fromData] = data;
        }
        ,
        clear() {
            this.id = "",
                this.editmode = false;
            this.list_name = "";
            //this.$refs.item_name.value  = "";
            //this.$refs.item_label.value = "";
            this.list = [];
        },
        cancel() {
            this.clear();
            $(".nav-tabs > li > a#add_dropdown-tab > span").trigger('click');
        },
        editSave(key) {
            //var index = this.$root.$refs.fields_builder_add_field.DD_List.findIndex(x => x.name === key);
            //alert("kk"+JSON.stringify(this.$root.$refs.add_field.DD_List, null, 4));
            /* this.$refs.list_name.value = this.$root.$refs.fields_builder_add_field.DD_List[index].name;
            this.id = this.$root.$refs.fields_builder_add_field.DD_List[index].id;
            this.list =this.$root.$refs.fields_builder_add_field.DD_List[index].options;
            this.editmode = true; */
        },

        showToast(message, type) {
            this.isVisible = true;
            this.message = message;
            this.type = type;
        },

        submit() {
            this.errors = {};
            if (this.list_name === "") {
                this.showToast("Name should not be empty", "error");
                return;
            }

            if (this.list.length > 0) {
                axios.post('/dropdown/sub_create',
                    { name: this.list_name, options: this.list }
                ).then(response => {

                    this.showToast("Successfully Saved", "success");
                    this.clear();
                    console.log("service :" + response.data);
                }).catch(error => {
                    //console.log(error.response);
                    this.showToast("Failed", "error");
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            }
            else {
                this.showToast("Relationship is empty", "error");
            }

            // axios.post('/Dropdown', {name: this.$refs.list_name.value,options:this.list}).then(response => {
            //     this.$root.$refs.add_field.getDDList();
            //     alert('Message sent!');

            // }).catch(error => {
            //     if (error.response.status === 422) {
            //     this.errors = error.response.data.errors || {};
            //     }
            // });
        },
        get() {
            // this.errors = {};
            //  axios.get('dropdown/list').then(response => {
            //     console.log(response.data);

            //     this.ddlist = response.data;
            //     var keys = [];

            //     for (var k in this.ddlist){
            //         keys.push(k);
            //     } 

            //     console.log("KEYS::"+keys[0]);

            //     //
            // }).catch(error => {
            //     if (error.response.status === 422) {
            //     this.errors = error.response.data.errors || {};
            //     }
            // });
        },

        showDropdown() {
            // this.$inertia.get("dropdown/view/list");
            this.$inertia.get("../../dd/dropdown");

        },
        add() {
            const name = this.$refs.item_name.value.trim();
            const label = this.$refs.item_label.value.trim();

            if (!name || !label) return;
            // Add new item
            this.list.push({
                name,
                label,
                isEditing: false
            });

            // Clear input fields
            this.$refs.item_name.value = "";
            this.$refs.item_label.value = "";
            this.$refs.item_name.focus();
        },
        removeAt(idx) {
            this.list.splice(idx, 1);
        },
        // editTask(idx) {
        //     if (this.list[idx].isEditing) {
        //         this.list[idx].isEditing = false;
        //     } else {
        //         this.list[idx].isEditing = true;
        //     }
        //     // let taskName = event.target.getAttribute('data-name');
        //     // let taskLabel = event.target.getAttribute('data-label');
        //     // let taskId = event.target.getAttribute('data-id');

        //     // this.$refs.item_name.value = taskName;
        //     // this.$refs.item_label.value = taskLabel;
        //     // this.buttonText = 'Update';
        //     // this.editIndex = idx;
        // }
        toggleEdit(idx) {
            this.list[idx].isEditing = !this.list[idx].isEditing;
            // if (this.list[idx].isEditing) {
            //     // Save changes and exit edit mode
            //     this.list[idx].isEditing = false;
            // } else {
            //     // Enable edit mode
            //     this.$set(this.list, idx, { ...this.list[idx], isEditing: true });
            // }
        },
    }
}
</script>
<style>
.button {
    margin-top: 35px;
}

.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #d7dde4;
}

.list-group {
    min-height: 20px;
}

.list-group-item {
    cursor: move;
}

.list-group-item i {
    cursor: pointer;
}

.closefa,
.editfa {
    cursor: pointer;
    float: right;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.editfa {
    margin-right: 10px;
}
</style>